import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';

import MapIcon from '@material-ui/icons/AddLocation';
import CardIcon from '@material-ui/icons/GridOn';
import ChartIcon from '@material-ui/icons/ShowChart';
import WeatherIcon from '@material-ui/icons/WbSunny';
import ShareIcon from '@material-ui/icons/Share';
import HelpIcon from '@material-ui/icons/Help';


import { SidebarNav } from './components';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 140,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(0, 0)
  },
  nav: {
    marginBottom: theme.spacing(0)
  }
}));

const Sidebar = props => {
  const { open, variant, onClose, className, ...rest } = props;

  const classes = useStyles();

  const pages = [

    {
      title: 'Map',
      href: '/map',
      icon: <MapIcon />
    },
    {
      title: 'Card',
      href: '/card',
      icon: <CardIcon />
    },
    {
      title: 'Chart',
      href: '/chart',
      icon: <ChartIcon />
    },
    {
      title: 'Weather',
      href: '/weather',
      icon: <WeatherIcon />
    }
  
  ];

    const pages2 = [
    {
      title: 'Share',
      href: '/share',
      icon: <ShareIcon />
    },
    {
      title: 'Help',
      href: '/help',
      icon: <HelpIcon />
    }
  
  ];

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
      
        <SidebarNav
          className={classes.nav}
          pages={pages}
        />
        <Divider className={classes.divider} />
        <SidebarNav
          className={classes.nav}
          pages={pages2}
        />
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
